import * as React from 'react';
import { LoadingSpinner as LoadingSpinnerBase } from '@blend/consumer-components';

import * as deploymentConfig from 'login-utils/deploymentConfig';

const actionColor = deploymentConfig.getOrganizationColors().action;

export default class LoadingSpinner extends React.PureComponent {
  render() {
    return <LoadingSpinnerBase color={actionColor} size="lg" />;
  }
}
